import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import PermissionWrapper from '@/components/UI/PermissionWrapper/PermissionWrapper'

interface ActionButtonsProps {
  editMode: boolean
  buttonText: string
  onSave: () => void
  onCancel: () => void
  onCreate: () => void
  className?: string
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  editMode,
  buttonText,
  onSave,
  onCancel,
  onCreate,
  className = '',
}) => {
  const { t } = useTranslation('translation')

  return (
    <div className={`d-flex align-items-center flex-wrap ${className}`}>
      {editMode && (
        <PermissionWrapper>
          <Button
            variant="contained"
            color="primary"
            onClick={onSave}
            sx={{ mx: 1 }}
          >
            {t('Save')}
          </Button>
        </PermissionWrapper>
      )}
      {!editMode && (
        <PermissionWrapper>
          <Button
            variant="contained"
            color="primary"
            className="third-step"
            onClick={onCreate}
          >
            {editMode ? t('Save') : buttonText}
          </Button>
        </PermissionWrapper>
      )}
      {editMode && (
        <Button
          variant="outlined"
          color="primary"
          onClick={onCancel}
          sx={{ mx: 1 }}
        >
          {t('Cancel')}
        </Button>
      )}
    </div>
  )
}

export default ActionButtons
